module.exports = __webpack_public_path__ + "img/mama-o-kimchi_thumbnail.15d0c8b7.jpg";